/**
 * 中文文案字典
 * 所有界面文案集中在此，模板用 $t('key')、逻辑层用 this.$t('key') 取值
 */
export default {
  nav: {
    title: '泰克智能知识库助手',
    newSession: '新对话',
    locale: '语言',
    more: '更多',
    zh: '中文',
    en: 'English',
    cancel: '取消',
    theme: '主题切换',
    lightMode: '浅色模式',
    darkMode: '深色模式',
    model: 'AI 模型',
  },
  welcome: {
    title: '你好，我是智能小泰',
    desc: '向 小泰 提问，它将从泰克知识库中汇总知识为您解答',
  },
  input: {
    placeholder: '基于泰克知识库提问',
  },
  disclaimer: '回答内容均由 AI 生成，仅供参考',
  faq: {
    title: '常见问题',
    desc: '试试点击下方问题，快速获取答案',
  },
  source: {
    title: '回答参考的内容来源',
    preview: '点击预览文件',
    copyLink: '复制下载链接',
  },
  linkAction: {
    title: '文档链接',
    preview: '预览',
    copyLink: '复制下载链接',
    open: '打开来源',
  },
  viewer: {
    videoLoadFailed: '视频加载失败',
    videoErrorDesc: '链接可能受限或签名过期，请复制到浏览器打开',
    copyVideoLink: '复制视频链接',
    download: '下载文件',
    notSupported: '该文件类型暂不支持在线预览',
    filePreview: '文件预览',
  },
  ref: {
    title: '引用片段',
    chunkUnavailable: '该引用对应的原文片段暂不可用，可点击下方按钮查看来源文档。',
    notFound: '未找到对应的引用内容。',
    viewDoc: '查看文档',
    openSource: '打开来源',
  },
  model: {
    selectTitle: '选择 AI 模型',
    group: 'AI 模型',
    current: '✓ 当前使用',
  },
  toast: {
    answerError: '回答出错，请重试',
    answerIncomplete: '回答不完整，请重试',
    answerInterrupted: '回答中断，请重试',
    noAnswer: '抱歉，未能获取到答案。',
    qaFailed: '问答失败：',
    networkError: '网络异常',
    refNotFound: '未找到对应的引用内容',
    noDownloadLink: '该文件暂无可用的下载链接',
    linkCopied: '链接已复制，仅1小时内有效，请及时下载',
    copyFailed: '复制失败，请手动复制链接',
    searchFailed: '搜索失败：',
    stopGenerate: '停止生成',
  },
  search: {
    found: '为您找到 {count} 个相关文件：',
    notFound: '未找到相关文件，请尝试其他关键词。',
    unnamedFile: '未命名文件',
  },
  theme: {
    toLight: '切换到浅色模式',
    toDark: '切换到深色模式',
  },
  fileType: {
    video: '视频',
    audio: '音频',
    image: '图片',
  },
};
